import { render, staticRenderFns } from "./header-search-primary.vue?vue&type=template&id=408b2b7a&scoped=true&"
import script from "./header-search-primary.vue?vue&type=script&lang=js&"
export * from "./header-search-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b2b7a",
  null
  
)

export default component.exports